export const numberToMinuteSecondString = (number: number) => {
  return `${number}`.length === 1 ? `0${number}` : `${number}`;
};
